import React, { useState } from 'react';
import MapView from './components/MapView';

export default function App() {
  const [cameras, setCameras] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState(null);

  return (
    <div className="bg-[#18181b] min-h-screen w-full" style={{ minHeight: "100vh" }}>
      {/* MAP - edge-to-edge */}
      <div
        style={{
          width: "100vw",
          maxWidth: "100vw",
          height: "100vh",
          minHeight: 400,
          margin: 0,
          padding: 0,
          position: "relative",
        }}
        className="relative"
      >
        <MapView
          cameras={cameras}
          setCameras={setCameras}
          selectedCameraId={selectedCameraId}
          setSelectedCameraId={setSelectedCameraId}
        />
      </div>
    </div>
  );
}
